import { createActions } from 'redux-actions';

export const { updateUserAction } = createActions('UPDATE_USER_ACTION');
